/* eslint-disable jsdoc/require-param-type */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { AudioPlayer } from 'functional-foundations'
import { iconBackgroundStyle } from 'colors'
import EditContactModal from 'edit-contact-modal'
import { removeContactFromCalls, addContactsToCalls, updateCall } from '../actions/calls'
import LoadingBar from 'loading-bar'
import gtmDataPush from 'gtm-events'
import API from '../util/api_v5'
import PhoneComUser from 'phone-com-user'
import { IconButton, Typography, Icon, Divider, Avatar } from 'foundations-library/components'
import { withStyles } from '@material-ui/core'
import { MyPhoneContactContext } from 'providers'
import DisplayName from 'display-name'
import PropTypes from 'prop-types'
import { getFeatureEnabled } from 'feature-flag'
import { formatPhoneNumber } from 'phone-numbers'
import { ThemeContext } from 'providers'
import CallDetailsTabs from './CallDetailsTabs'

const mapStateToProps = (state) => ({
    smallView: state.smallView,
    calls: state.calls
})
const mapDispatchToProps = (dispatch) => ({
    updateCall: (call) => dispatch(updateCall(call)),
    addContactsToCalls: (contacts) => dispatch(addContactsToCalls(contacts)),
    removeContactFromCalls: (contactId) => dispatch(removeContactFromCalls(contactId))
})

/**
 *
 */
export const incomingCall = 'incoming'
/**
 *
 */
export const outgoingCall = 'outgoing' // eslint-disable-line no-unused-vars

/**
 *
 * @param unix_timestamp
 */
export const getDateAndTime = (unix_timestamp) => {
    const myTime = new Date(unix_timestamp * 1000)
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    const dayName = days[myTime.getDay()]
    const monthName = myTime.toLocaleString('default', { month: 'short' })
    const day = myTime.getDate()
    const year = myTime.getFullYear()
    let hours = myTime.getHours()
    const minutes = myTime.getMinutes().toString().padStart(2, '0')
    const ampm = hours >= 12 ? 'PM' : 'AM'
    hours = hours % 12
    hours = hours || 12
    return `${dayName} ${monthName} ${day}, ${year} ${hours}:${minutes} ${ampm}`.replace('  ', ' ')
}

/**
 *
 * @param duration
 */
export const formatDuration = (duration) => {
    return duration > 60
        ? `${Math.floor(duration / 60)} Min ${duration % 60} Sec`
        : `${duration} Seconds`
}

const styles = (theme) => {
    const { colors } = theme['foundations-library']

    return {
        callContent: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative'
        },
        mainContentWrapper: {
            heigth: '100%',
            overflowY: 'auto',
            margin: '0 32px'
        },
        mainContent: {
            padding: '40px 0',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            height: 'fit-content',
            position: 'relative',
            width: '100%',
            maxWidth: 800,
            margin: '0 auto',
            rowGap: '30px',
            '&.small-view': {
                padding: '0 20px'
            }
        },
        itemIcon: {
            position: 'relative',
            width: 100,
            height: 100,
            minHeight: 100,
            backgroundColor: '#eee',
            borderRadius: '50%',
            boxSizing: 'border-box',
            marginLeft: 'auto',
            marginBottom: 25
        },
        iconImage: {
            position: 'absolute',
            height: '100%',
            left: '50%',
            top: '50%',
            borderRadius: '50px',
            transform: 'translate(-50%, -50%)'
        },
        infoWrapper: {
            display: 'flex',
            justifyContent: 'space-between',
            '& .info-item': {
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                '& .title': {
                    fontSize: 28,
                    fontWeight: 500
                }
            }
        },
        callInfoBar: {
            display: 'flex',
            alignItems: 'center',
            padding: '8px 20px',
            boxShadow: '1px 0 0 1px #e0e0e0',
            lineHeight: 1.36
        },
        dateTimeInfo: {
            flex: 3,
            display: 'flex',
            justifyContent: 'space-between',
            borderRight: '1px solid #e0e0e0',
            paddingRight: 10,
            '& > span:last-child': {
                textTransform: 'uppercase',
                fontWeight: 'bold',
                color: theme.palette.primary.main
            }
        },
        contactInfo: {
            flex: 1,
            minWidth: 150,
            paddingLeft: 10,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        audioPlayerWrapper: {
            position: 'relative',
            marginTop: 40
        },
        recIcons: {
            display: 'flex',
            justifyContent: 'center',
            '& .rec-icon': {
                width: 65,
                height: 40,
                color: '#88969E',
                '&:not(last-child):first-child': {
                    marginRight: 10
                }
            }
        },
        recordingInfo: {
            display: 'flex',
            justifyContent: 'center',
            marginTop: 50,
            fontStyle: 'italic',
            color: 'gray'
        },
        recordingsSeparator: {
            borderTop: '1px dashed lightgray',
            marginTop: 40
        },
        loadingBar: {
            marginBottom: 28
        },
        header: {
            display: 'flex',
            minHeight: '54px',
            padding: '0 20px',
            alignItems: 'center',
            alignSelf: 'stretch',
            background: colors.neutral[50],
            boxShadow: '0 -1px 0 0 #D9D8D8 inset',
            '& .vert-icon': {
                marginLeft: 'auto'
            }
        },
        contactPersonInfo: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '12px'
        },
        info: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '8px',
            '& .nameWrapper, & .actionWrapper': {
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                alignSelf: 'stretch'
            },
            '& .actionWrapper': {
                '& .icon-button': {
                    backgroundColor: `${colors.neutral[900]} !important`,
                    '&.text-icon': {
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }
                },
                '& .icon': {
                    cursor: 'pointer',
                    '&.notification-alert-icon': {
                        transform: 'rotate(180deg)'
                    }
                }
            }
        },
        callDetails: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            borderRadius: '14px',
            border: `1px solid ${colors.neutral[100]}`,
            '& .header': {
                display: 'flex',
                padding: '15px 30px',
                alignItems: 'center',
                alignSelf: 'stretch',
                borderRadius: '14px 14px 0 0',
                borderBottom: `1px solid ${colors.neutral[100]}`,
                background: colors.neutral[50]
            },
            '& .content': {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                alignSelf: 'stretch',
                '& .container': {
                    display: 'flex',
                    padding: '30px 30px 20px 30px',
                    alignItems: 'flex-start',
                    gap: '10px',
                    alignSelf: 'stretch',
                    background: 'rgba(242, 241, 241, 0.50)',
                    '& .left': {
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: '10px',
                        flex: '1 0 0',
                        '& .icon-container': {
                            display: 'flex',
                            padding: '8px',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '10px',
                            borderRadius: '6px',
                            background: 'rgba(217, 216, 216, 0.50)'
                        },
                        '& .call-info-container': {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            gap: '6px',
                            flex: '1 0 0',
                            '& .call-info': {
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                '& .call-type': {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '4px'
                                },
                                '& .call-number': {
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    gap: '4px'
                                }
                            },
                            '& .location-container': {
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                '& .location': {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '4px'
                                }
                            }
                        }
                    },
                    '& .right': {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        gap: '6px',
                        '& .call-number': {
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                            gap: '4px',
                            alignSelf: 'stretch'
                        }
                    }
                }
            },
            '& .recording-summary': {
                display: 'flex',
                padding: '20px 30px 10px 30px',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '20px',
                alignSelf: 'stretch',
                '& .recording-container': {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    alignSelf: 'stretch',
                    borderRadius: '14px',
                    border: `1px solid ${colors.neutral[100]}`,
                    '& .recording': {
                        display: 'flex',
                        padding: '25px 0',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        alignSelf: 'stretch',
                        '& .recording-header': {
                            display: 'flex',
                            padding: '0 30px',
                            alignItems: 'center',
                            gap: '6px',
                            alignSelf: 'stretch'
                        },
                        '& .recording-content': {
                            display: 'flex',
                            padding: '40px 30px 0 30px',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '20px',
                            alignSelf: 'stretch',
                            borderRadius: '6px 6px 0 0'
                        }
                    }
                },
                '& .call-transcript-container': {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    alignSelf: 'stretch'
                }
            },
            '& .general-component': {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'stretch',
                alignSelf: 'stretch',
                padding: '30px'
            }
        }
    }
}

class CallContent extends Component {
    static contextType = ThemeContext

    state = {
        iconColor: null,
        recordingPlayFromSecond: null,
        voicemailPlayFromSecond: null,
        callingEnabled: false,
        displayName: ''
    }

    static contextType = MyPhoneContactContext

    componentDidMount () {
        this.init()
        getFeatureEnabled('calling_enabled').then(async enabled => {
            this.setState({ callingEnabled: enabled || (!process.env.REACT_APP_IS_CALLING_DISABLED) })
        })
    }

    async componentDidUpdate (prevProps) {
        if (this.props.currentCall && this.props.currentCall.isTempCall) {
            // upon getting call log event, fetch the call log. bringing in call log into event would involve doing that for every single call
            const voipId = PhoneComUser.getAPIAccountId()
            const call = await API.getCall(this.props.currentCall.id, voipId)
            if (call && call.id) {
                // if there is id's get the recording and voicemail data at same time.
                if ((call.recording && call.recording.id) || (call.voicemail && call.voicemail.id)) {
                    const recordings = []
                    const voicemails = []
                    if (call.recording.id) recordings.push(call.recording.id)
                    if (call.voicemail.id) voicemails.push(call.voicemail.id)

                    const res = await API.getCallRecordings(recordings, voicemails)
                    if (res.recordings.length > 0) call.recording = res.recordings[0]
                    if (res.voicemails.length > 0) call.voicemail = res.voicemails[0]
                }

                this.props.updateCall(call)
                this.props.switchCallLog(call)
                // TODO: maybe force fetch the voicemail and recording
            }
        }
        this.init()
    }

    init = () => {
        const currentCall = this.props.currentCall
        if (currentCall && currentCall.id !== this.currentId) {
            this.currentId = currentCall.id

            const otherContact = this.getOtherContact()

            this.setState({
                iconColor: iconBackgroundStyle(this.props.theme, [otherContact.number])
            })

            const number = otherContact.number
            const name = otherContact.name

            this.context.getDisplayName(name || number).then(
                contextDisplayName => {
                    if (contextDisplayName && contextDisplayName !== this.state.displayName) this.setState({ displayName: contextDisplayName })
                }
            ).catch(err => console.error(err))

            this.setState({ otherContact: otherContact })
        }

        if (this.props.calls.items && this.props.calls.items.length && !currentCall) {
            const call = this.props.calls.items[0]
            this.props.switchCallLog(call)
        }

        if (currentCall) {
            this.type = currentCall.type.charAt(0).toUpperCase() + currentCall.type.slice(1)
        }
    }

    onPlay = () => {
        const currentCall = this.props.currentCall
        gtmDataPush({
            PDC_Action: `${currentCall.recording.url ? 'recording' : 'voicemail'}-recording-played`
        })
    }

    editContact = (id, number) => {
        this.setState({ editContact: { id, number: id ? '' : number } })
    }

    getContact = () => {
        const extraContacts = this.props.extraContacts
        const editContact = this.state.editContact
        const contactId = editContact ? editContact.id : null
        if (!editContact || !contactId || !extraContacts) return null
        let contact = null
        this.props.extraContacts.forEach((c) => (c.id === contactId ? (contact = c) : null))
        return contact
    }

    saveContact = (contact) => {
        const extraContacts = this.props.extraContacts
        const isNew = !extraContacts.find((c) => c.id === contact.id)
        this.props.updateContact(contact)
        if (isNew) this.props.addContactsToCalls([contact])
        this.setState({ editContact: null })
        // NOTE: This line below is a workaround in order the contact name in the header to get changed immediately after the contact is saved.
        this.props.switchCallLog(this.props.currentCall)
    }

    deleteContact = (contactId) => {
        this.props.deleteContact(contactId)
        // NOTE: This line below is a workaround in order the contact name in the selector to get removed immediately after the contact is deleted.
        this.props.switchCallLog(this.props.currentCall)
        this.setState({ editContact: null })
    }

    startPlayback = (type, second) => {
        if (type === 'recording') this.setState({ recordingPlayFromSecond: second })
        else if (type === 'voicemail') this.setState({ voicemailPlayFromSecond: second })
    }

    onAudioError = async () => {
        const currentCall = this.props.currentCall
        if (currentCall) {
            await this.props.retryRecordings(currentCall)
            this.setState({})
        }
    }

    renderHeader = (classes) => {
        return (
            <div className={classes.header}>
                <IconButton
                    color='neutral'
                    name='more-vert'
                    variant='icon'
                    size='large'
                    className='vert-icon'
                />
            </div>
        )
    }

    getOtherContact = () => {
        let otherContact = null
        const currentCall = this.props.currentCall
        const theOtherDirection = currentCall.type === 'outgoing' ? 'to' : 'from'
        otherContact = currentCall[theOtherDirection]
        const extraContacts = this.props.extraContacts
        extraContacts.forEach((c) => {
            if (otherContact.contactId) return
            const contactNumbers = c.numbers.map((n) => n.number)
            if (contactNumbers.includes(otherContact.number)) {
                otherContact.name = c.name.display
                otherContact.contactId = c.id
            }
        })
        return otherContact
    }

    otherContactNumber = () => {
        const otherContact = this.state.otherContact
        const callerNumber = otherContact.number
        return callerNumber
    }

    startConversation = (phoneNumber) => {
        const extensionId = parseInt(this.props.routeProps.location.pathname.split('/')[1].substring(1))
        const redirectPath = `/e${extensionId}/messages/new-conversation/${phoneNumber}`
        this.props.routeProps.history.push(redirectPath)
    }

    makeCall = () => {
        if (this.props.extension.is_virtual || this.props.isCallButtonDisabled) return
        this.props.makeCall(this.otherContactNumber())
    }

    getDisplayNameForAvatar = () => {
        const displayName = this.state.displayName

        if (this.haveAlpha(displayName)) return displayName

        return displayName.replace(/\D/g, '')
    }

    haveAlpha = (displayName) => /[a-zA-Z]+/.test(displayName)

    renderComponent = (component) => {
        return (
            <div className={'general-component'}>
                {component}
            </div>
        )
    }

    onContactsClick = () => {
        const otherContact = this.state.otherContact
        const participant = otherContact
        const phoneNumber = participant.number
        const name = participant.name
        const contactId = participant.contactId
        const formatedNumber = formatPhoneNumber(phoneNumber)
        const displayName = name || formatedNumber
        const prefillData = this._getContactPrefillData(formatedNumber, displayName, participant)
        this.editContact(contactId, phoneNumber, prefillData)
    }

    _getContactPrefillData = (formatedNumber, name, participant) => {
        let prefillData = null
        if (name !== formatedNumber) prefillData = { name }
        if (participant.address) {
            if (!prefillData) prefillData = {}
            prefillData.address = participant.address
        }
        return prefillData
    }

    doesOtherContactExist = () => {
        const otherContact = this.state.otherContact
        return Boolean(otherContact?.contactId)
    }

    getContactIcon = () => {
        const props = {
            color: 'neutral-900',
            name: this.doesOtherContactExist() ? 'notification-alert' : 'add-user',
            onClick: this.onContactsClick,
            'data-testid': this.doesOtherContactExist() ? 'edit-contact-icon' : 'add-contact-icon',
            title: this.doesOtherContactExist() ? 'Edit Contact' : 'Add Contact',
            size: this.doesOtherContactExist() ? 32 : 'small',
            className: this.doesOtherContactExist() ? 'icon notification-alert-icon' : 'icon-button',
            variant: this.doesOtherContactExist() ? undefined : 'contained'
        }
        return this.doesOtherContactExist() ? <button title='Edit Contact'><Icon {...props} /></button> : <IconButton {...props} />
    }

    render () {
        const { classes } = this.props
        const theme = this.context
        const currentCall = this.props.currentCall
        if (!currentCall) return ''
        const fromNumber = currentCall.from.number
        const toNumber = currentCall.to.number
        const recordingStatus = currentCall.recording.url ? 'loaded' : currentCall.recording.loading ? 'loading' : 'none'
        const voicemailStatus = currentCall.voicemail.url ? 'loaded' : currentCall.voicemail.loading ? 'loading' : 'none'
        const showVoicemailSection = currentCall.voicemail && currentCall.voicemail.url && currentCall.type === 'incoming'

        return (
            <div className={classes.callContent}>
                {this.renderHeader(classes)}

                <div className={classes.mainContentWrapper}>
                    <div className={`${classes.mainContent} ${this.props.smallView ? 'small-view' : ''}`}>
                        <div className={classes.contactPersonInfo}>
                            {
                                this.doesOtherContactExist()
                                    ? (
                                        <Avatar initials={this.getDisplayNameForAvatar()} size='large' />
                                    )
                                    : (
                                        <Icon
                                            color='neutral-700'
                                            name='contacts'
                                            size={80}
                                            data-testid='contacts-icon'
                                        />
                                    )
                            }

                            <div className={classes.info}>
                                <div className='nameWrapper'>
                                    <Typography variant='h5' data-testid='name'>
                                        <DisplayName value={this.state.displayName}/>
                                    </Typography>
                                </div>
                                <div className='actionWrapper'>
                                    {this.state.callingEnabled && <IconButton
                                        color='neutral-900'
                                        name='call'
                                        variant='contained'
                                        size='small'
                                        className='icon-button'
                                        onClick={this.makeCall}
                                        data-testid='make-call-button'
                                        title='Call number'
                                    />}
                                    <IconButton
                                        color='neutral-900'
                                        name='text'
                                        variant='contained'
                                        size='small'
                                        className='icon-button text-icon'
                                        onClick={() => this.startConversation(currentCall.type === incomingCall ? fromNumber : toNumber)}
                                        data-testid='start-conversation-button'
                                        title='Start conversation'
                                    />
                                    {this.getContactIcon()}
                                    {/* <IconButton
                                        color='neutral-900'
                                        name='fax-alt-1'
                                        variant='contained'
                                        size='small'
                                        className='icon-button'
                                    /> */}
                                </div>
                            </div>
                        </div>
                        <div className={classes.callDetails}>
                            <div className='header'>
                                <Typography variant='subtitle1'>
                                    Call detail
                                </Typography>
                            </div>
                            <div className='content'>
                                <div className='container'>
                                    <div className='left'>
                                        <div className='icon-container'>
                                            <Icon name={currentCall.type === incomingCall ? 'call-incoming' : 'call-outgoing'} data-testid={currentCall.type === incomingCall ? 'call-incoming-icon' : 'call-outgoing-icon'} size='medium' color='neutral-900' />
                                        </div>
                                        <div className='call-info-container'>
                                            <div className='call-info'>
                                                <div className='call-type'>
                                                    <Typography variant='body3heavy' color='neutral-700' data-testid={currentCall.type === incomingCall ? 'Incoming call' : 'Outgoing call'}>
                                                        {currentCall.type === incomingCall ? 'Incoming call' : 'Outgoing call'}
                                                    </Typography>
                                                    <Typography variant='body4' color='neutral-900'>
                                                        ({formatDuration(currentCall.duration)})
                                                    </Typography>
                                                </div>
                                                <div className='call-number'>
                                                    <Typography variant='h7' color='neutral-700'>
                                                        {currentCall.type === incomingCall ? 'From:' : 'To:'}
                                                    </Typography>
                                                    <Typography variant='h7' color='neutral-900' data-testid={currentCall.type === incomingCall ? fromNumber : toNumber}>
                                                        <DisplayName value={currentCall.type === incomingCall ? fromNumber : toNumber} />
                                                    </Typography>
                                                </div>
                                            </div>
                                            {/* <div className='location-container'>
                                                <div className='location'>
                                                    <Icon name='location' size='small' color='neutral-700' />
                                                    <Typography variant='subtitle3' color='neutral-700'>
                                                        Lakewood, NJ
                                                    </Typography>
                                                </div>
                                                <Typography variant='subtitle3' color='neutral-700'>
                                                    Maybe: Pager duty company
                                                </Typography>
                                            </div> */}
                                        </div>
                                    </div>
                                    <div className='right'>
                                        <Typography variant='body3' color='neutral-900' style={{ alignSelf: 'flex-end' }}>
                                            {getDateAndTime(currentCall.start_time)}
                                        </Typography>
                                        <div className='call-number'>
                                            <Typography variant='subtitle3' color='neutral-500'>
                                                {currentCall.type === incomingCall ? 'To:' : 'From:'}
                                            </Typography>
                                            <Typography variant='body3heavy' color='neutral-900' data-testid={currentCall.type === incomingCall ? toNumber : fromNumber}>
                                                <DisplayName value={currentCall.type === incomingCall ? toNumber : fromNumber} />
                                            </Typography>
                                        </div>
                                        {/* <Typography variant='captionLight' color='neutral-500' style={{ alignSelf: 'flex-end' }}>
                                            Answered by Ext 200
                                        </Typography> */}
                                    </div>
                                </div>
                                <Divider color='neutral-100' marginTop={0} marginBottom={0} />
                            </div>
                            <div className='recording-summary'>
                                {theme.showNoRecordingMessage && <div className='recording-container'>
                                    {currentCall.recording.url && <div className='recording'>
                                        <div className='recording-header'>
                                            <Icon name='equalizer' size='medium' color='neutral-900' />
                                            <Typography variant='subtitle1' color='neutral-900'>Call recording</Typography>
                                        </div>
                                        <div className='recording-content'>
                                            <AudioPlayer
                                                key={currentCall.id}
                                                url={currentCall.recording.url}
                                                onPlay={this.onPlay}
                                                playFromSecond={this.state.recordingPlayFromSecond}
                                                onError={this.onAudioError}
                                            />
                                        </div>
                                    </div>}
                                    {recordingStatus === 'loading' ? this.renderComponent(<LoadingBar />) : (recordingStatus === 'none' ? this.renderComponent(<Typography variant='body3' color='neutral-900'>No recording available</Typography>) : '')}
                                </div>}
                                {showVoicemailSection && <div className='recording-container'>
                                    {currentCall.voicemail.url && <div className='recording'>
                                        <div className='recording-header'>
                                            <Icon name='equalizer' size='medium' color='neutral-900' />
                                            <Typography variant='subtitle1' color='neutral-900'>Voicemail recording</Typography>
                                        </div>
                                        <div className='recording-content'>
                                            <AudioPlayer
                                                key={currentCall.id}
                                                url={currentCall.voicemail.url}
                                                onPlay={this.onPlay}
                                                playFromSecond={this.state.voicemailPlayFromSecond}
                                                onError={this.onAudioError}
                                            />
                                        </div>
                                    </div>}
                                    {voicemailStatus === 'loading' ? this.renderComponent(<LoadingBar />) : (voicemailStatus === 'none' ? this.renderComponent(<Typography variant='body3' color='neutral-900'>No voicemail available</Typography>) : '')}
                                </div>}
                                <div className='call-transcript-container'>
                                    {currentCall.recording.url && <CallDetailsTabs call={currentCall} doesOtherContactExist={this.doesOtherContactExist()} />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <EditContactModal
                    type={this.state.editContact ? (this.state.editContact.id ? 'Edit' : 'Add') : false}
                    onClose={() => this.setState({ editContact: null })}
                    fixedNumber={this.state.editContact ? this.state.editContact.number : null}
                    contact={this.getContact()}
                    contactGroupTypes={this.props.contactGroupTypes}
                    saveContact={this.saveContact}
                    deleteContact={this.deleteContact}
                    makeCall={this.props.makeCall}
                    startConversation={this.startConversation}
                    addGroup={this.props.addGroup}
                    updateGroupId={this.props.updateGroupId}
                    isVirtualExtension={this.props.extension.is_virtual}
                    smallView={this.props.smallView}
                />
            </div>
        )
    }
}

CallContent.propTypes = {
    currentCall: PropTypes.object,
    updateCall: PropTypes.func,
    switchCallLog: PropTypes.func,
    calls: PropTypes.object,
    classes: PropTypes.object,
    extraContacts: PropTypes.array,
    updateContact: PropTypes.func,
    addContactsToCalls: PropTypes.func,
    deleteContact: PropTypes.func,
    extension: PropTypes.object,
    onCallRecent: PropTypes.func,
    redirect: PropTypes.func,
    retryRecordings: PropTypes.func,
    currentCallSession: PropTypes.object,
    smallView: PropTypes.bool,
    contactGroupTypes: PropTypes.array,
    makeCall: PropTypes.func,
    addGroup: PropTypes.func,
    updateGroupId: PropTypes.func,
    theme: PropTypes.object,
    isCallButtonDisabled: PropTypes.bool,
    routeProps: PropTypes.object
}

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(CallContent))
